import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import HomeBanner1 from "../ones/HomeBanner1";
import PageHero from "../ones/PageHero"; 
import servicesHeroBg from '../assets/image31.jpeg'; // Badala ya picha ya asili ya background

import Footer from "../ones/Footer";
import HomeBanner2 from "../ones/HomeBanner2";
import ServicesBanner1 from "../ones/ServicesBanner1";
import CustomersBanner from "../ones/CustomersBanner";
import NewsBanner from "../ones/NewsBanner";
import PageWithSidebar from "../components/PageWithSidebar";

export default function View(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    //run initializations here
    setReady(false);
    //..
    
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [ ])

  if(ready) {
    return (
      <>
      <PageHero 
          bgImage={servicesHeroBg}
          kicker="Habari & Matukio"
          heading="Habari Mbalimbali"
          paragraph="Fuatilia habari za hivi punde, matukio muhimu, taarifa za maendeleo na mabadiliko ya kidijitali ndani ya chama chetu cha ushirika."
        />
        <PageWithSidebar>
          <NewsBanner/>
        </PageWithSidebar>
        <Footer/>
      </>
    )
  } else {
    return (
      <div 
        className="container mSupportLoading"
      >
        {getInlineLoader()}
      </div>
    );
  }

  
}
